<template>
  <thread-header-container>
    <thread-home-header
      v-if="thread.type === 'home_message'"
      :thread-color="getThreadColor(thread.type)"
      :thread="thread"
      @open-home-details="$emit('open-home-details', $event)"
    />
    <thread-home-header
      v-else-if="thread.type === 'provide_feedback_message'"
      :thread-color="getThreadColor(thread.type)"
      :thread="thread"
      @open-home-details="$emit('open-home-details', $event)"
    />
    <thread-home-header
      v-else-if="thread.type === 'offer_message'"
      :thread-color="getThreadColor(thread.type)"
      :thread="thread"
      @open-home-details="$emit('open-home-details', $event)"
    />
    <thread-default-header
      v-else-if="thread.type === 'common_message'"
      :thread-color="getThreadColor(thread.type)"
      :thread="thread"
    />
    <thread-default-header
      v-else-if="thread.type === 'route_schedule_message'"
      :thread-color="getThreadColor(thread.type)"
      :thread="thread"
    />
  </thread-header-container>
</template>

<script>
import ThreadHeaderContainer from '../ThreadHeaderContainer'
import ThreadHomeHeader from './ThreadHomeHeader'
import ThreadDefaultHeader from './ThreadDefaultHeader'
import getThreadColorMixin from '../../mixins/getThreadColorsMixin'

export default {
  components: {
    ThreadHomeHeader,
    ThreadHeaderContainer,
    ThreadDefaultHeader
  },
  mixins: [getThreadColorMixin],
  props: {
    thread: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
